import {AccessTokenInfo} from "dto/auth/Authentication"
import {showNotification} from "common/Notification"

export const getLocalAccessTokenInfo = () => {
    try {
        const localTokenInfo = localStorage.getItem("accessToken") || ""
        return JSON.parse(localTokenInfo) as AccessTokenInfo
    } catch (error) {
        showNotification("로그인후 이용 가능합니다")
        window.location.href = "/login"
        throw new Error("이용 가능한 토큰이 없습니다")
    }

}
export const setLocalAccessToken = async (tokenInfo: AccessTokenInfo | undefined | null) => {
    if (tokenInfo) {
        await localStorage.clear()
        await localStorage.setItem("accessToken", JSON.stringify(tokenInfo))
    }
}
